import settings from "../../config/settings";
import { isMultiExtension } from "../data/multiextensiondomains";

export const parseExtension = (extension, domain) => {
  // If we know the domain and it's NOT multi-extension, leave as-is — the
  // first 4 digits are part of the real extension, not a prefix.
  if (domain && !isMultiExtension(domain)) {
    return extension;
  }

  if (
    extension &&
    settings.accountPrefixApp &&
    settings.accountPrefixPhy &&
    (extension?.startsWith(settings.accountPrefixApp) ||
      extension?.startsWith(settings.accountPrefixPhy))
  ) {
    return extension?.split("@")[0]?.substring(4);
  }

  return extension;
};

export const isPhysicalExtension = (description) => {
  return description?.match(/\d+,\d+,\d+,\d+/);
};
